var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12","xl":"8","lg":"12"}},[_c('urun-navigasyon')],1),_c('v-col',{staticClass:"pt-5",attrs:{"cols":"12","xl":"8","lg":"12"}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }